// import { createSelector } from 'reselect'

const getState = state => state.book
const isLoadingSelector = state => getState(state).isLoading
const departureTimeSelector = state => getState(state).departureTime
const savedBookingSelector = state => getState(state).savedBooking

export {
  isLoadingSelector,
  departureTimeSelector,
  savedBookingSelector
}


// WEBPACK FOOTER //
// ./src/reduxModules/selectors/BookSelectors.js